"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditScoreTree = void 0;
var MerkleTree_1 = __importDefault(require("./MerkleTree"));
var ethers_1 = require("ethers");
var CreditScoreTree = /** @class */ (function () {
    function CreditScoreTree(creditScores) {
        this.ensureUniqueAccounts(creditScores);
        this.tree = new MerkleTree_1.default(creditScores.map(function (_a) {
            var account = _a.account, amount = _a.amount;
            return CreditScoreTree.toNode(account, amount);
        }));
    }
    CreditScoreTree.verifyProof = function (account, amount, proof, root) {
        var pair = CreditScoreTree.toNode(account, amount);
        for (var _i = 0, proof_1 = proof; _i < proof_1.length; _i++) {
            var item = proof_1[_i];
            pair = MerkleTree_1.default.combinedHash(pair, item);
        }
        return pair === root;
    };
    CreditScoreTree.toNode = function (account, amount) {
        return ethers_1.utils.solidityKeccak256(['address', 'uint256'], [account, amount]);
    };
    CreditScoreTree.prototype.getHexRoot = function () {
        return this.tree.getHexRoot();
    };
    CreditScoreTree.prototype.getProof = function (account, amount) {
        return this.tree.getProof(CreditScoreTree.toNode(account, amount));
    };
    CreditScoreTree.prototype.ensureUniqueAccounts = function (creditScores) {
        creditScores.map(function (creditScore, idx, arr) {
            var numberOfScoresPerAccount = creditScores.filter(function (_a) {
                var account = _a.account;
                return account === creditScore.account;
            }).length;
            if (numberOfScoresPerAccount > 1) {
                throw Error("Credit score for " + creditScore.account + " is not unique");
            }
        });
    };
    return CreditScoreTree;
}());
exports.CreditScoreTree = CreditScoreTree;
exports.default = CreditScoreTree;
//# sourceMappingURL=CreditScoreTree.js.map